export default "__VITE_ASSET__DnxpzG5R__"